<div class="option-item" [class.selected]="isSelected">
  <div class="option-item-content">
    @if (showCheckbox) {
    <sg-checkbox [items]="[{ value: option.value, checked: isSelected}]"></sg-checkbox>
    } @if (option?.prefixIcon) {
    <mat-icon>{{option.prefixIcon}}</mat-icon>
    }
    <span class="option-label"><sg-text variant="sg-body-medium-regular" class="sg-option-label">{{ option?.label }}</sg-text></span>
  </div>
  @if (isSelected && showSelectedIcon) {
  <mat-icon class="selected-check">small-check-square</mat-icon>
  }
</div>
